export class Threshold {
  constructor(
    readonly value: number,
    readonly color: string,
    readonly label: string,
    readonly labelColor: string,
    readonly labelHidden?: boolean,
  ) {}
}
